export default {
    addTokens: 'Add Tokens',
    addTokensNow: 'Do you want to add tokens now?',
    author: 'Author',
    autoplaying: 'Auto Playing',
    buyTokens: 'Buy Tokens',
    chatArchives: 'Chat Archives',
    confirmJoinGroupShow: 'Join group show?',
    confirmRequestGroupShow: 'Request group show?',
    confirmRequestPrivateShow: 'Request private show?',
    confirmRequestVoyeurShow:
        'Accessing private video... The model will not be able to see what you type in their public chatroom.',
    createFreeAccount: 'Create a Free Account',
    created: 'Created',
    createAnAccount: 'Create an Account',
    deleteNote: 'Delete Note',
    endShow: 'End Show',
    goToRoom: 'Go to Room',
    group: 'Group',
    guest: 'guest',
    hideVideo: 'Hide Video',
    insertDate: 'Insert Date',
    login: 'Log In',
    logs: 'Logs',
    lounge: 'Lounge',
    loungeDescription: 'An exclusive room for Premium Members',
    lounge1000: 'Lounge 1K',
    lounge1000Description:
        'An exclusive room for Premium Members with 1000+ Rewards Points',
    lounge10000: 'Lounge 10K',
    lounge10000Description:
        'An exclusive room for Premium Members with 10000+ Rewards Points',
    markAllRead: 'Mark All Read',
    menu: 'Menu',
    messageSettings: 'Message Settings',
    next: 'Next',
    nextModel: 'Next Model',
    nextRoom: 'Next Room',
    noResultsFound: 'No results found',
    noteCommandWithoutPermission:
        'The /note command is only available to Premium Members. Please buy tokens one time to become a Premium Member forever.',
    notesSelectUser: 'Select a user to view notes',
    notesUserListEmpty: 'Add a user to get started',
    participants: 'Participants',
    pmFromPmWarning:
        'The /pm command is not supported while in a private message.',
    pmWarningIfNotPremium:
        'Private messages to models may only be sent by Premium Members. Please buy tokens to become a Premium Member forever. Please note that some models might opt to befriend you before they can accept your private messages even as a Premium member',
    pmWithoutUsername: 'You must include a username.',
    pmWithoutValidUsername: 'You must include a valid username.',
    previous: 'Previous',
    prevModel: 'Prev Model',
    prevRoom: 'Prev Room',
    private: 'Private',
    profile: 'Profile',
    purchaseTokens: 'Purchase Tokens',
    quickbuyCommandWithoutPermission:
        'The /quickbuy command is only available to Premium Members. Please buy tokens one time to become a Premium Member forever.',
    results: 'Results',
    resultsFound: 'Results found',
    roomTopic: 'Room Topic',
    selectAChatLogToView: 'Select a chat log to view',
    send: 'Send Message',
    sendChatMessage: 'Send chat message...',
    sendPrivateMessage: 'Send private message...',
    sendPM: 'Send PM',
    showVideo: 'Show Video',
    sortBy: 'Sort by',
    spendingTokensOnShows: 'Spending Tokens on Shows',
    spy: 'Spy',
    startAutoPlaying: 'Start Auto Play',
    autoPlayOptions: 'Auto Play Options',
    tip: 'Tip',
    tipMenu: 'Tip Menu',
    tipCommandWithoutPermission:
        'The /tip command is only available to Premium Members. Please buy tokens one time to become a Premium Member forever.',
    tokenStorageCommandWithoutPermission:
        'Token storage commands are only available to Premium Members. Please buy tokens one time to become a Premium Member forever.',
    truePrivate: 'True Private',
    truePrivateOnly:
        'This model is currently only accepting True Private show requests.',
    truePrivateTooltipMessage:
        'TruePrivate costs 80 tokens per minute instead of 60 for a normal private show and no one is able to spy on it.',
    truePrivateTooltipTitle: 'What is True Private?',
    upBuyDefault:
        'Your request could not be sent because you have fewer tokens than the minimum required.',
    upBuyGroup:
        'Your group show request could not be sent because you have fewer tokens than the minimum set by the model to join a group show.',
    upBuyPrivate:
        'Your private show invitation could not be sent because you have fewer tokens than the minimum set by the model to initiate a private show.',
    upBuyVoyeur:
        'Your voyeur show request could not be sent because you have fewer tokens than the minimum set by the model to join a voyeur show.',
    voyeur: 'Voyeur',
    whisperFromLoungeWarning:
        'The /whisper command is not supported while in the Lounge.',
    whisperFromPmWarning:
        'The /whisper command is not supported while in a private message.',
    whiteboard: 'Whiteboard',
    youAreAlreadyParticipating: 'You are already participating in the show.',
    youAreAlreadyWaiting: 'You are already waiting for the show to start.',
    youMustBeLoggedInToRequestAShow: 'You must be logged in to request a show',
}
